import React, { useEffect, useState } from 'react';
import CreatableSelect from 'react-select/creatable';
import { Controller, useForm } from 'react-hook-form';
import axios from 'axios';
import styles from "./OnHold.module.sass";
import OrderPackage from '../../../../models/OrderPackage'
import { PageType, PageOptionType, PageOption } from '../../../../models'

const OnHold = ({ orderPackageId, onHold, onHoldReason }) => {
  const { register, control, trigger, watch, setValue, unregister } = useForm();
  const watchOnHold = watch("on_hold");
  const watchOnHoldReason = watch("on_hold_reason");
  const data = watch();
  const [orderPackage, setOrderPackage] = useState();
  const [newOnHoldReasons, setNewOnHoldReasons] = useState([]);

  useEffect(() => {
    OrderPackage
      .find(orderPackageId)
      .then((response) => {
        setOrderPackage(response.data)
      })
  }, [orderPackageId])

  useEffect(() => {
    if (!orderPackage) return;

    orderPackage.onHold = data.on_hold;
    orderPackage.onHoldReason = data.on_hold_reason;

    orderPackage.save()
  }, [data])

  useEffect(() => {
    PageType
      .includes({ pageOptionTypes: 'pageOptions' })
      .where({ name: 'On Hold' })
      .first()
      .then(res => {
        setNewOnHoldReasons(res.data.pageOptionTypes.map((pageOptionType) => pageOptionType.pageOptions).flat())
      })
  }, [])

  useEffect(() => {
    setValue("on_hold", onHold);
    setValue("on_hold_reason", onHoldReason);
  }, []);

  const onHoldReasons = () => {
    return (
      newOnHoldReasons.map((option) => {
        return(
          {label: option.name , value: option.name }
        )
      }
      )
    )
  }

  return (
    <form className={styles.form}>
      <div className={styles.formGroup}>
        <input
          type="checkbox"
          className={styles.checkbox}
          {...register("on_hold")} />
        <label className={styles.label}>Order on hold?</label>
      </div>

      {watchOnHold && (
        <Controller
          control={control}
          name="on_hold_reason"
          render={({ field, value }) => (
            <CreatableSelect
              {...field}
              isClearable
              onChange={(e) => setValue('on_hold_reason', e && e.value)}
              options={onHoldReasons()}
              placeholder="Select reason (type to enter)"
              className={styles.reasonInput}
              value={onHoldReasons().find(s => s.value === watchOnHoldReason)}
            />
          )}
        />
      )}
    </form>
    )
}

export default OnHold;
